// extracted by mini-css-extract-plugin
export var container = "RightSidebar-module--container--IBIiI";